module.exports = { injectCss: () => {} }